/**
 * WARNING
 *
 * Do not add anything here. Feel free to delete things.
 * New things should only be added to angularjs apps.
 * See webapp-ajs to see how routes match to specific modules.
 *
 */

import * as angular from 'angular';

import { MoveSpaceModalService } from '~/components/modal-move-space/move-space-modal.service';
import { ChartEffects } from '~/ngrx-compat/chart';
import { FlamingoGfEffects } from '~/ngrx-compat/flamingo-gf';
import { ScheduleModalEffects } from '~/ngrx-compat/schedule-modal';
import { HomeEffects } from '~/ngrx-compat/home';

import { CalcFieldsService } from '../services/calc-fields-service';
import ChartDataService from '../services/chart-data-service';
import { ChartDesignerService } from '../services/chart-designer/chart-designer.service';
import { ChartExplorerService } from '../services/chart-designer/chart-explorer.service';
import { ChartViewService } from '../services/chart-view.service';
import DataSourceService from '../services/data-source.service';
import { DefinitionRunService } from '../services/definition-run-service';
import { ExplorationVizService } from '../services/exploration/exploration-viz.service';
import { ExplorationsIndexViewDataService } from '../services/explorations-index-view-data.service';
import { FavIconService } from '../services/favicon-service';
import { FlamingoFilterService } from '../services/flamingo-filter-service';
import { FlamingoService } from '../services/flamingo-service';
import { FullscreenService } from '../services/fullscreen-service';
import { LoggingService } from '../services/logging-service';
import { NotebookDataService } from '../services/notebook-data-service';
import { ReportFilterService } from '../services/report-filter-service';
import { ReportRunDataService } from '../services/report-run-service';
import { ReportSaveService } from '../services/report-save-service';
import { ReportStateService } from '../services/report-state-service';
import { RouterStoreService } from '../services/router-store-service';
import { SpaceSearchService } from '../services/space-search-service';
import ViewService from '../services/view-service';
import { ExplorationViewDataService } from './report-viewer/services';
import { ApiModule } from '@mode/legacy/data-access-model-js';
import { CappieReporterService } from '@mode/shared/util-cappie-reporter';
import { downgradeInjectable } from '@angular/upgrade/static';
import { StatesDataService } from '../services/states-data-service';
import { AssetsModule } from './assets.module';
import { SocketService } from '@mode/shared/data-access-socket';

/**
 * @deprecated No new services should be added. Please add to specific app modules.
 */
export const AppServicesModule = angular
  .module('mode.app.services', [AssetsModule, ApiModule])
  .service('ReportFilterService', ReportFilterService)
  .service('DataSourceService', DataSourceService)
  .service('RouterStoreService', RouterStoreService)
  .service('ChartDataService', ChartDataService)
  .service('ChartViewService', ChartViewService)
  .service('ReportSaveService', ReportSaveService)
  .service('ReportStateService', ReportStateService)
  .service('StatesDataService', StatesDataService)
  .service('ViewService', ViewService)
  .service('SocketService', SocketService)
  .service('SpaceSearchService', SpaceSearchService)
  .service('ReportRunDataService', ReportRunDataService)
  .service('CappieReporterService', downgradeInjectable(CappieReporterService))
  .service('NotebookDataService', NotebookDataService)
  .service('ExplorationViewDataService', ExplorationViewDataService)
  .service('ExplorationsIndexViewDataService', ExplorationsIndexViewDataService)
  .service('DefinitionRunDataService', DefinitionRunService)
  .service('LoggingService', LoggingService)
  .service('ChartDesignerService', ChartDesignerService)
  .service('ChartExplorerService', ChartExplorerService)
  .service('ExplorationVizService', ExplorationVizService)
  .service('FullscreenService', FullscreenService)
  .service('FavIconService', FavIconService)
  .service('FlamingoService', FlamingoService)
  .service('FlamingoFilterService', FlamingoFilterService)
  .service('CalcFieldsService', CalcFieldsService)
  .service('MoveSpaceModalService', MoveSpaceModalService).name;

angular
  .module('mode.app.services')
  .service('ChartEffects', ChartEffects)
  .service('FlamingoGfEffects', FlamingoGfEffects)
  .service('ScheduleModalEffects', ScheduleModalEffects)
  .service('HomeEffects', HomeEffects);
